module.exports = __webpack_public_path__ + "img/1575210760.7304f426.jpg";